import React, { useEffect, useState } from 'react';
import { PaymentOptionCard } from './PaymentOptionsCard';
import { CashPaymentOption, PaymentDetails } from '../types';
import VenmaIcon from '@/assets/img/venmo.svg';
import ZelleIcon from '@/assets/img/zelle.svg';
import PayPalIcon from '@/assets/img/paypal.svg';
import ChequeIcon from '@/assets/img/cheque.svg';
import CashIcon from '@/assets/img/cash.svg';
type Props = {
  paymentDetails?: PaymentDetails;
  onSelect: (po: CashPaymentOption) => void;
};

export const PaymentOptions = ({ paymentDetails, onSelect }: Props) => {
  const paymentOptions: CashPaymentOption[] = [
    {
      name: 'Venmo',
      label: 'Venmo',
      description: 'Pay using Venmo',
      icon: VenmaIcon,
    },
    {
      name: 'Zelle',
      label: 'Zelle',
      description: 'Pay using Zelle',
      icon: ZelleIcon,
    },
    {
      name: 'PayPal',
      label: 'PayPal',
      description: 'Pay using PayPal',
      icon: PayPalIcon,
    },
    {
      name: 'Cheque',
      label: 'Bank Cheque',
      description: 'Pay using Cheque',
      icon: ChequeIcon,
    },
    {
      name: 'Cash',
      label: 'In Cash',
      description: 'Pay using Cash',
      icon: CashIcon,
    },
    {
      name: 'Others',
      label: 'Others',
      description: 'Other payment options',
      icon: undefined,
    },
  ];
  const [selectedCashPayment, setSelectedCashPayment] = useState<CashPaymentOption>();
  useEffect(() => {
    if (paymentDetails?.data) {
      if (paymentDetails?.type === 'cash') {
        setSelectedCashPayment(paymentDetails.data as CashPaymentOption);
      } else {
        setSelectedCashPayment(undefined);
      }
    } else {
      setSelectedCashPayment(undefined);
    }
  }, [paymentDetails]);
  useEffect(() => {
    if (selectedCashPayment) onSelect(selectedCashPayment);
  }, [selectedCashPayment]);

  return (
    <div className="payment-options-container">
      <p>Pay using other payment mode</p>
      <div className="payment-options">
        {paymentOptions.map((po, index) => (
          <PaymentOptionCard
            data={po}
            onSelect={() => {
              setSelectedCashPayment(po);
            }}
            isSelected={selectedCashPayment && selectedCashPayment.name === po.name ? true : false}
          />
        ))}
      </div>
    </div>
  );
};
